import React, { useEffect, useRef } from 'react'
import JobListings from './JobListings'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { toast } from '../common/Toast/toast';

function JobSection() {
  const navigate = useNavigate();
  const hasShownToast = useRef(false);
  const { hasPermission } = useAuth();
  useEffect(() => {
    if (!hasPermission('job-section', 'view','lms')) {
      if (!hasShownToast.current) {
        toast.error('You do not have permission to add departments.');
        navigate('/');
        // console.log("hello")
        hasShownToast.current = true;
      }
    }
  }, [hasPermission, navigate]);

  return (
    <div>

        {/* <LocationSelector /> */}
        <JobListings />
    </div>
  )
}

export default JobSection